export function toIPv4(ip) {
    if (!ip) {
        return undefined;
    }
    return ip.substring(0, 7) === '::ffff:' ? ip.substring(7) : ip;
}
